var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.456 4.692a1 1 0 0 1 0 1.415l-2.829 2.828 2.829 2.828a1 1 0 0 1-1.414 1.415l-2.829-2.829-2.828 2.829a1 1 0 0 1-1.414-1.415l2.828-2.828-2.828-2.828a1 1 0 1 1 1.414-1.415l2.828 2.829 2.829-2.829a1 1 0 0 1 1.414 0Z",
    fill: "currentcolor",
    fillRule: "nonzero"
  })));
};

export default SvgClose;